/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationMessage } from '../../models/notification-message';
import { PasswordVerificationDto } from '../../models/password-verification-dto';

export interface ApiPasswordresetResetPost$Params {
  'api-version'?: string;
      body?: PasswordVerificationDto
}

export function apiPasswordresetResetPost(http: HttpClient, rootUrl: string, params?: ApiPasswordresetResetPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
  const rb = new RequestBuilder(rootUrl, apiPasswordresetResetPost.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationMessage>;
    })
  );
}

apiPasswordresetResetPost.PATH = '/api/passwordreset/reset';
